import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import campaignApi from 'api/campaignApi';
import { formatQueryParams } from "helpers/format";

export const getCampaigns = createAsyncThunk("campaigns" , async (params: any = {}) => {
  try{
    const response = await campaignApi.campaigns(formatQueryParams(params))
    return response;
  }catch (error) {
    return error;
  }
});

export const getCampaignGroups = createAsyncThunk("campaign-groups" , async (params: any = {}) => {
  try{
    const response = await campaignApi.campaignGroups(formatQueryParams(params))
    return response;
  }catch (error) {
    return error;
  }
});

export const deleteCampaignGroup = async (id: string | number , data: any = {}) => {
  try{
    const response = await campaignApi.deleteCampaignGroup(id, data);
    return response;
  }catch (error) {
    return error;
  }
};


export const getCampaignsByNormal = async (params: any = {}) => {
  try{
    const response = await campaignApi.campaigns(params)
    return response;
  }catch (error) {
    return error;
  }
};

export const getCampaignGroupsNormal = async (params: any = {}) => {
  try{
    const response = await campaignApi.campaignGroups(params)
    return response;
  }catch (error) {
    return error;
  }
};

export const getDetailCampaign = async (id:string | number , params: any = {}) => {
  try{
    const response = await campaignApi.campaign(id, params)
    return response;
  }catch (error) {
    return error;
  }
};

export const getDetailCampaignGroup = async (id:string | number , params: any = {}) => {
  try{
    const response = await campaignApi.campaignGroup(id, params)
    return response;
  }catch (error) {
    return error;
  }
};


export const postCampaign = async (data: any = {}) => {
  try{
    const response = await campaignApi.postCampaign(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putCampaign = async (id: string | number ,  data: any = {}) => {
  try{
    const response = await campaignApi.putCampaign(id, data);
    return response;
  }catch (error) {
    return error;
  }
};

export const postCampaignGroups = async (data: any = {}) => {
  try{
    const response = await campaignApi.postCampaignGroups(data);
    return response;
  }catch (error) {
    return error;
  }
};
export const  putCampaignStatus = async (data: any = {}) => {
  try{
    const response = await campaignApi.putCampaignStatus(data);
    return response;
  }catch (error) {
    return error;
  }
};
export const postCampaignMultiMedia = async (data: any = {}) => {
  try{
    const response = await campaignApi.postCampaignMultiMedia(data);
    return response;
  }catch (error) {
    return error;
  }
};


export const putCampaignMultiMedia = async (id: string | number ,  data: any = {}) => {
  try{
    const response = await campaignApi.putCampaignMultiMedia(id, data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putCampaignGroupMultiMedia = async (id: string | number ,  data: any = {}) => {
  try{
    const response = await campaignApi.putCampaignGroupMultiMedia(id, data);
    return response;
  }catch (error) {
    return error;
  }
};

export const deleteCampaign = async (id: string | number , data: any = {}) => {
  try{
    const response = await campaignApi.deleteCampaign(id, data);
    return response;
  }catch (error) {
    return error;
  }
};

export const exportFileCampaign = async (params: any = {}) => {
  try{
    const response = await campaignApi.exportFileCampaign(params);
    return response;
  }catch (error) {
    return error;
  }
};


export const postCampaignSports = async (data: any = {}) => {
  try{
    const response = await campaignApi.postCampaignSports(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const getCampaignSports = async (params: any = {}) => {
  try{
    const response = await campaignApi.getCampaignSports(params)
    return response;
  }catch (error) {
    return error;
  }
};

export const deleteTeamInCampaignSport = async (data: any = {}) => {
  try{
    const response = await campaignApi.deleteTeamInCampaignSport(data);
    return response;
  }catch (error) {
    return error;
  }
};
